import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriberService {

  ApiURL = environment.ApiURL;
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  getAllSubscriber(): Observable<any> {
    return this.http.get(this.ApiURL + '/Subscriber', { headers: this.headers_token });
  }

}
